export const useIsDev = (): boolean => {
  const hostname = window.location.hostname;
  const isDev =
    import.meta.env.DEV ||
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("dev.") ||
    process.env.NODE_ENV === "development";
  return isDev;
};
